:host {
  display: block;
  width: 100%;
}

.quantity-selector {
  display: inline-flex;
  align-items: center;
  background: #e6e6e6;
  border-radius: 13px;
  padding: 3px;
  height: 100%;
  max-height: 20px;
}

.quantity-selector-button:disabled {
  fill: #ccc;
}

.quantity-selector-button {
  outline: none;
  border: none;
  background-color: transparent;
  padding: 0;
  cursor: pointer;
}

.quantity-selector-button:disabled {
  cursor: default;
}

.quantity-selector-button svg {
  width: 18px;
  height: 18px;
}

.quantity-selector-button svg.outline { display: block; }
.quantity-selector-button svg.fill { display: none; }
.quantity-selector-button:not(:disabled):hover svg.outline { display: none; }
.quantity-selector-button:not(:disabled):hover svg.fill { display: block; }

.quantity-selector-value {
  padding: 0px 5px;
  cursor: default;
  text-align: center;
}
